import React from 'react'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import SuccessPayment from './../Public/Image/Home/SuccessPayment.svg'
import { setBottomSheetsuccessfulPayment } from './../app/Home'
import { useLocation } from 'react-router-dom';
import xpplus from './../Public/Image/Join/xpplus.svg'
import Person from './../Public/Image/Home/person_black_24dp 1.svg'
import View from './../Public/Image/Home/visibility_black_24dp (2).svg'
import useStore from '../Zustand/AppSetting'
import { LoaderCircle, Loader } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

const SuccessfulPayment = ({ UserNameForOrder, Mode,Emoji, CountCrypto,PostCountCrypto }) => {
    const dispatch = useDispatch()
    // const UserNameForOrder = useSelector((state) => state.Home.UserNameForOrder)
    const BottomSheetsuccessfulPayment = useSelector((state) => state.Home.BottomSheetsuccessfulPayment)
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const Count = searchParams.get('count');
    const UserName = searchParams.get('username');
    const PaymentReturn = searchParams.get('payment');
    const PaymentReturnView = searchParams.get('paymentview');
    const Point = searchParams.get('point');
    const CountPost = searchParams.get('countPost');
    const paymentReturnreact = searchParams.get('paymentreact');
    const emoji = searchParams.get('emoji');
    const messageid = searchParams.get('id')
    const history = useHistory();

    const { market, data, loading, error, fetchData } = useStore()

    useEffect(() => {
        // console.log(emoji)
        // console.log(CountPost)
        // console.log(status)
        fetchData('WebAppP')
    }, [])
    function onDismiss() {
        setTimeout(() => {
            dispatch(setBottomSheetsuccessfulPayment(false))
        }, 300);
    }
    // console.log(emoji)
    const emojiList = data?.data?.appSetting?.emojiList || [];
    let em = emoji?.replace(/^["'](.*)["']$/, "$1")
    const foundEmoji = emojiList.find(item => item.emoji === em);
    // console.log(emoji)
    // console.log(data)
    //  
    //  let emojilast
    // useEffect(() => {
    //  console.log(emojiList)
    //  console.log(typeof emoji); // باید باشه: 'string'

    // //  const emoji1 = String(emoji);

    //   emojilast = emojiList.find(item=>item.emoji === emoji)
    //   console.log(emojilast)  
    // }, [emojilast,emojiList])

    // console.log(Count)
    //    console.log(emojilast)
    // console.log(CountCrypto ,UserNameForOrder)
    // console.log(PostCountCrypto)
    // console.log(Count)
    return (
        <BottomSheet onDismiss={onDismiss} open={BottomSheetsuccessfulPayment}>
            {/* <BottomSheet onDismiss={onDismiss} open={true}> */}

            <div className='RegisterBeforeBottomSheet'>

                <div className='ShowPriceAndChannelBottomSheetBody'>
                    <div className='successfulPaymentItem'>

                        <div className='UnsuccessfulPaymentValue'>
                            <img src={SuccessPayment} className='UnsuccessfulPaymentImg' />
                            Successful Order
                        </div>
                        <div className='SuccessfulPaymentText'>
                            {/* {CountCrypto} +  */}
                            {Count ? Count :CountCrypto } 
                            {/* {
                                PaymentReturn === 'true' ?
                                   <>
                                   <img src={Person} style={{ width: "21px", height: "14px" }} />
                                    Are sending to
                                   </> 
                                    :
                                    PaymentReturnView === 'true' ?
                                        <>
                                        <img style={{ width: "21px", height: "14px" }} src={View} />
                                        :
                                        CountPost == 1 ?
                                             have been registered for the single post at 
                                        :
                                        CountPost > 1 ?  have been registered for the last ${CountPost} posts at : null
                                        </>
                                        
                            } */}
                            {UserNameForOrder ?

                                Mode == 'member' ?
                                    <>
                                        <img src={Person} style={{ width: "21px", height: "21px", margin: '0 4px' }} alt="Person" />
                                        Are sending to
                                    </>
                                    :
                                    Mode == 'view' ?
                                        <>
                                            <img src={View} style={{ width: "21px", height: "21px", margin: '0 4px' }} alt="View" />
                                            {CountPost == '1' ? "have been registered for the single post at "
                                                :
                                                CountPost > 1
                                                    ? `have been registered for the last ${CountPost} posts at `
                                                    : null}
                                                     {PostCountCrypto == '1' ? "have been registered for the single post at "
                                                :
                                               `have been registered for the last ${CountPost?CountPost:PostCountCrypto} posts at `
                                                   }
                                                    
                                        </>
                                        :
                                        Mode == 'react' ?
                                            <>
                                                <div className='emojiInbottomSheet' style={{ "margin": '0 2px' }}>
                                                    {
                                                        foundEmoji ?
                                                            // <img src={foundEmoji?.image} width={16} height={16} style={{ margin: "0 8px 0 8px" }} />
                                                            foundEmoji?.emoji
                                                            // emoji
                                                            :
                                                           Emoji
                                                            // <div className="spin1">
                                                            //     <LoaderCircle size={16} />

                                                            // </div>
                                                        // http://localhost:3000/Home?paymentreact=true&username=dollar_tehran3bze&count=100&point=1&countPost=1&Status=Member&emoji=%F0%9F%A4%AA
                                                    }

                                                </div>

                                                {/* <img src={emojiList[0].image} style={{ width: "21px", height: "14px" }} alt="View" /> */}
                                                are sending to



                                            </>
                                            :
                                            null :

                                null}
                            <>
                                {PaymentReturn === "true" ? (
                                    <>
                                        <img src={Person} style={{ width: "21px", height: "21px", margin: '0 4px' }} alt="Person" />
                                        Are sending to
                                    </>
                                ) : PaymentReturnView === "true" ? (
                                    <>
                                        <img src={View} style={{ width: "21px", height: "21px", margin: '0 4px' }} alt="View" />
                                        {CountPost == '1' ? "have been registered for the single post at "
                                            :
                                            CountPost > 1
                                                ? `have been registered for the last ${CountPost} posts at `
                                                : null}
                                    </>
                                ) :

                                    paymentReturnreact === "true" ? (
                                        <>
                                            <div className='emojiInbottomSheet' style={{ "margin": '0 2px' }}>
                                                {
                                                    foundEmoji ?
                                                        // <img src={foundEmoji?.image} width={16} height={16} style={{ margin: "0 8px 0 8px" }} />
                                                        foundEmoji?.emoji
                                                        // emoji
                                                        :
                                                        <div className="spin1">
                                                            <LoaderCircle size={16} />

                                                        </div>
                                                    // http://localhost:3000/Home?paymentreact=true&username=dollar_tehran3bze&count=100&point=1&countPost=1&Status=Member&emoji=%F0%9F%A4%AA
                                                }

                                            </div>

                                            {/* <img src={emojiList[0].image} style={{ width: "21px", height: "14px" }} alt="View" /> */}
                                            are sending to



                                        </>
                                    )
                                        : null


                                }
                            </>

                            {/* messageid */}
                            <span style={{ "font-weight": "bold" }}>
                                &nbsp;https://t.me/
                               {UserNameForOrder} {UserName} {paymentReturnreact === "true" || PaymentReturnView == "true" ? '/' + messageid : null}</span>
                        </div>
                        {Point > 0 && Point != 'undefined' ? <div style={{ "marginTop": "4px", "marginBottom": "4px" }}>+</div> : null}
                        <div>
                            {Point > 0 && Point != 'undefined' ? <div className='pointInBottomSheet'>{Point} <img src={xpplus} className='XpCountInlistIcon' style={{ "width": "14px", "height": "14px", "marginLeft": "4px" }} /></div> : null}
                        </div>
                    </div>

                </div>
                <div className='RegisterBeforeBottomSheetFooter'>
                    {
                        // PaymentReturn || PaymentReturnView ?
                        <Link to='/Orders' className='BottomSheetShowPriceAndChannelButton' style={{ background: "#fff", color: '#1976D2', marginRight: '5px' }} onClick={() => onDismiss()}>Track order</Link>
                        // : null
                    }


                    <button className='BottomSheetShowPriceAndChannelButton' onClick={() => {onDismiss();history.push("/");}}>Got it</button>

                </div>
            </div>
        </BottomSheet>
    )
}

export default SuccessfulPayment